import Vue from "vue";
import Router from "vue-router";
import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";
import Components_backup from "./views/components_backup.vue";
import Landing from "./views/Landing.vue";
import Login from "./views/Login.vue";
import Profile from "./views/Profile.vue";
import CauHoiThuongGap from "./views/components/tro-giup/CauHoiThuongGap.vue";
import HuongDanSuDung from "./views/components/tro-giup/HuongDanSuDung.vue";
import ChiTiet from "./views/ChiTiet.vue";
import TuyenDung from "./views/TuyenDung.vue";
import VueResource from 'vue-resource';
import DieuKhoanDichVu from "./views/components/bao-mat-va-dieu-khoan/DieuKhoan.vue";
import ChinhSachBaoMat from "./views/components/bao-mat-va-dieu-khoan/BaoMat.vue";

Vue.use(Router);
Vue.use(VueResource);

export default new Router({
    linkExactActiveClass: "active",
    routes: [{
            path: "/gioi-thieu",
            name: "components",
            components: {
                header: AppHeader,
                default: Components_backup,
                footer: AppFooter
            }
        },
        {
            path: "/",
            name: "landing",
            components: {
                header: AppHeader,
                default: Landing,
                footer: AppFooter
            }
        },
        {
            path: "/tin-tuc",
            name: "login",
            components: {
                header: AppHeader,
                default: Login,
                footer: AppFooter
            }
        },
        {
            path: "/tuyen-dung",
            name: "tuyendung",
            components: {
                header: AppHeader,
                default: TuyenDung,
                footer: AppFooter
            }
        },
        {
            path: "/tro-giup",
            name: "help",
            components: {
                header: AppHeader,
                default: HuongDanSuDung,
                footer: AppFooter
            }
        },
        {
            path: "/profile",
            name: "profile",
            components: {
                header: AppHeader,
                default: Profile,
                footer: AppFooter
            }
        },
        {
            path: "/cau-hoi-thuong-gap",
            name: "cauhoithuonggap",
            components: {
                header: AppHeader,
                default: CauHoiThuongGap,
                footer: AppFooter
            }
        },
        {
            path: "/huong-dan-su-dung",
            name: "huongdansudung",
            components: {
                header: AppHeader,
                default: HuongDanSuDung,
                footer: AppFooter
            }
        },
        {
            path: "/chi-tiet/:Pid",
            name: "ChiTiet",
            components: {
                header: AppHeader,
                default: ChiTiet,
                footer: AppFooter
            }
        },
        {
            path: "/dieu-khoan-dich-vu",
            name: "dieukhoandichvu",
            components: {
                header: AppHeader,
                default: DieuKhoanDichVu,
                footer: AppFooter
            }
        },
        {
            path: "/chinh-sach-bao-mat",
            name: "chinhsachbaomat",
            components: {
                header: AppHeader,
                default: ChinhSachBaoMat,
                footer: AppFooter
            }
        },{
            path: "*",
            redirect: "/"
        }
    ],
    scrollBehavior: to => {
        if (to.hash) {
            return { selector: to.hash };
        } else {
            return { x: 0, y: 0 };
        }
    }
});